import LogActivity from './LogActivity';

export default LogActivity;
